// removed by extract-text-webpack-plugin
module.exports = {"section":"src-modules-products-EditProductView-StepAccommodationSettings-__ProductVariantFormSection__section--wET87"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/products/EditProductView/StepAccommodationSettings/ProductVariantFormSection.less
// module id = 1891
// module chunks = 0